import React, { useEffect, useState } from "react";
import { Box, Flex, Button, Modal, ModalOverlay, ModalContent } from "@chakra-ui/react";
import Editor from "components/Editor/Editor";
import { marked } from "marked";
import html2pdf from "html2pdf.js";
import { useHistory } from "react-router-dom";
import addAnimation from "assets/animations/ai.json";
import Lottie from "lottie-react";

function Step3({ formData, setCurrentStep }) {
  const { agreementType, country, signers } = formData;
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [agreement, setAgreement] = useState("");
  const [htmlContent, setHtmlContent] = useState("");

  const pdfOptions = {
    margin: 10,
    filename: `CogniSigner-${Date.now()}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  };

  const generatePrompt = () => {
    const signerInfo = signers
      .map((signer, index) => {
        let text = `Signer ${index + 1}:
        - Name: ${signer.name}
        - Email: ${signer.email}`;

        if (signer.company) {
          text += `
          - Company: ${signer.company}`;
        }

        if (signer.address) {
          text += `
            - Address: ${signer.address}`;
        }
      })
      .join("\n\n");

    const contentPrompt = `You are a professional lawyer working for a law firm. You have been asked to draft a ${agreementType} for a client in ${country}. The client has provided the following information:
    """
    ${signerInfo}
    """
    As per the information provided, please draft detailed terms and conditions appropriate for a ${agreementType} in the jurisdiction of ${country} country's law. The document needs to be in the markdown format with valid separators without any placeholder or input space for signature input, date field or anything else. Don't leave any placeholders, just create the document with all the details provided.`;
    return contentPrompt;
  };

  const generateAgreement = async () => {
    try {
      const response = await fetch("https://api-seyimfnmxq-uc.a.run.app/generateDocument", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prompt: generatePrompt(),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setAgreement(data.data);
        setHtmlContent(marked.parse(data.data));
      } else {
        console.error("Failed to generate agreement. Response status:", response.status);
      }
    } catch (error) {
      console.error("Error sending request to OpenAI:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateAgreement();
  }, []);

  const exportToPDF = () => {
    html2pdf().from(htmlContent).set(pdfOptions).save();
  };

  const exportToPDFAndRedirect = () => {
    html2pdf()
      .from(htmlContent)
      .set(pdfOptions)
      .outputPdf("blob")
      .then((pdfBlob) => {
        const fileBlob = new File([pdfBlob], "CogniSigner", { type: "application/pdf" });
        history.push({
          pathname: "/admin/add-signer",
          state: { pdfBlob: fileBlob, formData, text: agreement },
        });
      });
  };

  return (
    <Box>
      <Modal isOpen={loading} isCentered>
        <ModalOverlay />
        <ModalContent
          backgroundColor="transparent"
          boxShadow="none"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Lottie animationData={addAnimation} style={{ width: 400, height: 400 }} />
        </ModalContent>
      </Modal>
      {htmlContent !== "" ? (
        <Editor placeholder={htmlContent} onChange={(e) => setHtmlContent(e)} />
      ) : (
        <h2>Generating Document With CogniSigner AI!</h2>
      )}
      <Flex justifyContent="space-between" width="100%" mt="4rem">
        <Button
          isDisabled={loading}
          onClick={() => setCurrentStep(2)}
          bgColor="gray.200"
          color="black"
          _hover={{ color: "white", bgColor: "navy.400" }}
        >
          Back
        </Button>
        <Button
          isDisabled={loading}
          onClick={exportToPDF}
          bgColor="gray.200"
          color="black"
          _hover={{ color: "white", bgColor: "navy.400" }}
        >
          Download PDF
        </Button>
        <Button
          isDisabled={loading}
          onClick={exportToPDFAndRedirect}
          bgColor="gray.200"
          color="black"
          _hover={{ color: "white", bgColor: "navy.400" }}
        >
          E-Sign
        </Button>
      </Flex>
    </Box>
  );
}

export default Step3;
